import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMapPin } from "@fortawesome/sharp-solid-svg-icons"
import { Button, styled } from "@mui/material"
import { useListPlatformsBiomeshPlatformListGet } from "@phc/common/gen/threatAnalyticsGen"
import { useMemo } from "react"
import { extraColors } from "../../utils/theme"

const UnmappedButton = styled(Button)({
  textTransform: "none",
  fontWeight: 600,
  border: `1px solid ${extraColors.status.navyLight}`,
  color: extraColors.status.navyLight,
  "&:hover": {
    backgroundColor: extraColors.status.navyLightTransparent,
    border: `1px solid ${extraColors.status.navyLight}`,
  },
})

interface ViewUnmappedNodesButtonProps {
  active: boolean
  onToggle: () => void
}

export const ViewUnmappedNodesButton = ({
  active,
  onToggle,
}: ViewUnmappedNodesButtonProps) => {
  const { data: platforms } = useListPlatformsBiomeshPlatformListGet()

  const unmappedCount = useMemo(
    () => platforms?.filter(p => !p.centroid).length ?? 0,
    [platforms]
  )

  return (
    <UnmappedButton
      variant="outlined"
      size="small"
      startIcon={<FontAwesomeIcon icon={faMapPin} />}
      onClick={onToggle}
      sx={
        active
          ? {
              backgroundColor: extraColors.status.navyLightTransparent,
            }
          : undefined
      }
    >
      View Unmapped Nodes{unmappedCount > 0 ? ` (${unmappedCount})` : ""}
    </UnmappedButton>
  )
}
